import c0 from './1459147_controller';
import c1 from './admin/themes/color_choices_controller';
import c2 from './admin/themes/color_option_form_controller';
import c3 from './admin/themes/custom_conjunction_controller';
import c4 from './admin/themes/theme_builder_controller';
import c5 from './assignment_drag_controller';
import c6 from './async_block_controller';
import c7 from './auto_submit_form_controller';
import c8 from './autosize_controller';
import c9 from './autosubmit_file_controller';
import c10 from './carousel_controller';
import c11 from './checkbox_checked_count_controller';
import c12 from './checkbox_select_all_controller';
import c13 from './checkout_controller';
import c14 from './choices_controller';
import c15 from './confirm_leave_controller';
import c16 from './content_block_drag_controller';
import c17 from './counter_controller';
import c18 from './couples_controller';
import c19 from './couples_photo_upload_controller';
import c20 from './croppie_controller';
import c21 from './custom_header_image_controller';
import c22 from './custom_themes/color_picker_controller';
import c23 from './custom_themes/font_picker_controller';
import c24 from './debounced_auto_submit_controller';
import c25 from './disable_inputs_controller';
import c26 from './domain_checker_controller';
import c27 from './draggable_controller';
import c28 from './email_builder_controller';
import c29 from './event_form_controller';
import c30 from './event_guest_assignments_controller';
import c31 from './events/guest_table_controller';
import c32 from './file_upload_controller';
import c33 from './flatpickr_controller';
import c34 from './font_choices_controller';
import c35 from './form_controller';
import c36 from './gift_fund_contribution_confirmation_form_controller';
import c37 from './gift_fund_contribution_form_controller';
import c38 from './gift_fund_contributions_table_controller';
import c39 from './gift_fund_form_controller';
import c40 from './gift_fund_image_controller';
import c41 from './gift_fund_image_form_controller';
import c42 from './gift_list_basket_controller';
import c43 from './gift_list_form_controller';
import c44 from './gift_list_grid_controller';
import c45 from './gift_list_product_controller';
import c46 from './guest_bulk_event_assignments_controller';
import c47 from './guest_event_assignments_controller';
import c48 from './guest_import_form_controller';
import c49 from './guest_list_onboarding_controller';
import c50 from './guest_list_row_controller';
import c51 from './guests_form_controller';
import c52 from './guests_individual_controller';
import c53 from './hotel_event_controller';
import c54 from './hotel_grid_controller';
import c55 from './invitation_content_block_controller';
import c56 from './local_modal_controller';
import c57 from './mobile_menu_controller';
import c58 from './nested_form_controller';
import c59 from './off_canvas_menu_controller';
import c60 from './onboarding_events_form_controller';
import c61 from './onboarding_wedding_form_controller';
import c62 from './open_modal_controller';
import c63 from './palette_choices_controller';
import c64 from './password_peek_controller';
import c65 from './persist_state_controller';
import c66 from './photo_editor_controller';
import c67 from './popup_image_controller';
import c68 from './promo_banner_controller';
import c69 from './refresh_iframe_controller';
import c70 from './remote_color_picker_receiver_controller';
import c71 from './remote_color_picker_sender_controller';
import c72 from './remote_form_submitter_controller';
import c73 from './remote_modal_controller';
import c74 from './remote_page_controller';
import c75 from './responsive_iframe_controller';
import c76 from './rsvp/confirm_controller';
import c77 from './rsvp/continue_controller';
import c78 from './rsvp/detect_attending_controller';
import c79 from './rsvp/menu_choices_controller';
import c80 from './rsvp_form_controller';
import c81 from './rsvp_group/assign_controller';
import c82 from './rsvp_group/group_details_controller';
import c83 from './rsvp_group/transfer_controller';
import c84 from './selector_filters_controller';
import c85 from './self_destruct_controller';
import c86 from './send_to_guests_controller';
import c87 from './show_hide_controller';
import c88 from './show_hide_id_controller';
import c89 from './show_hide_selector_controller';
import c90 from './stationery/send_controller';
import c91 from './tabbed_controller';
import c92 from './tabbed_disable_inputs_controller';
import c93 from './tabbed_link_controller';
import c94 from './tabbed_param_controller';
import c95 from './tabbed_remote_controller';
import c96 from './tabbed_select_controller';
import c97 from './table_planner/guest_autocomplete_controller';
import c98 from './table_row_controller';
import c99 from './tabs_controller';
import c100 from './temporary_state_controller';
import c101 from './thankyou_row_controller';
import c102 from './thankyous_controller';
import c103 from './time_ago_controller';
import c104 from './toggle_boolean_controller';
import c105 from './toggle_controller';
import c106 from './tooltip_controller';
import c107 from './turnstile_controller';
import c108 from './user_ignored_controller';
import c109 from './voucher_code_controller';
import c110 from './website/contact_form_controller';
import c111 from './website/fetch_contact_form_controller';
import c112 from './website_anchor_tags_controller';
import c113 from './website_editor_controller';
import c114 from './wedding_date_controller';
import c115 from './yes_no_hide/local_controller';
import c116 from './yes_no_hide/long_range_controller';
import c117 from './yes_no_hide/yes_no_hide_controller';
export const definitions = [
	{identifier: '1459147', controllerConstructor: c0},
	{identifier: 'admin--themes--color-choices', controllerConstructor: c1},
	{identifier: 'admin--themes--color-option-form', controllerConstructor: c2},
	{identifier: 'admin--themes--custom-conjunction', controllerConstructor: c3},
	{identifier: 'admin--themes--theme-builder', controllerConstructor: c4},
	{identifier: 'assignment-drag', controllerConstructor: c5},
	{identifier: 'async-block', controllerConstructor: c6},
	{identifier: 'auto-submit-form', controllerConstructor: c7},
	{identifier: 'autosize', controllerConstructor: c8},
	{identifier: 'autosubmit-file', controllerConstructor: c9},
	{identifier: 'carousel', controllerConstructor: c10},
	{identifier: 'checkbox-checked-count', controllerConstructor: c11},
	{identifier: 'checkbox-select-all', controllerConstructor: c12},
	{identifier: 'checkout', controllerConstructor: c13},
	{identifier: 'choices', controllerConstructor: c14},
	{identifier: 'confirm-leave', controllerConstructor: c15},
	{identifier: 'content-block-drag', controllerConstructor: c16},
	{identifier: 'counter', controllerConstructor: c17},
	{identifier: 'couples', controllerConstructor: c18},
	{identifier: 'couples-photo-upload', controllerConstructor: c19},
	{identifier: 'croppie', controllerConstructor: c20},
	{identifier: 'custom-header-image', controllerConstructor: c21},
	{identifier: 'custom-themes--color-picker', controllerConstructor: c22},
	{identifier: 'custom-themes--font-picker', controllerConstructor: c23},
	{identifier: 'debounced-auto-submit', controllerConstructor: c24},
	{identifier: 'disable-inputs', controllerConstructor: c25},
	{identifier: 'domain-checker', controllerConstructor: c26},
	{identifier: 'draggable', controllerConstructor: c27},
	{identifier: 'email-builder', controllerConstructor: c28},
	{identifier: 'event-form', controllerConstructor: c29},
	{identifier: 'event-guest-assignments', controllerConstructor: c30},
	{identifier: 'events--guest-table', controllerConstructor: c31},
	{identifier: 'file-upload', controllerConstructor: c32},
	{identifier: 'flatpickr', controllerConstructor: c33},
	{identifier: 'font-choices', controllerConstructor: c34},
	{identifier: 'form', controllerConstructor: c35},
	{identifier: 'gift-fund-contribution-confirmation-form', controllerConstructor: c36},
	{identifier: 'gift-fund-contribution-form', controllerConstructor: c37},
	{identifier: 'gift-fund-contributions-table', controllerConstructor: c38},
	{identifier: 'gift-fund-form', controllerConstructor: c39},
	{identifier: 'gift-fund-image', controllerConstructor: c40},
	{identifier: 'gift-fund-image-form', controllerConstructor: c41},
	{identifier: 'gift-list-basket', controllerConstructor: c42},
	{identifier: 'gift-list-form', controllerConstructor: c43},
	{identifier: 'gift-list-grid', controllerConstructor: c44},
	{identifier: 'gift-list-product', controllerConstructor: c45},
	{identifier: 'guest-bulk-event-assignments', controllerConstructor: c46},
	{identifier: 'guest-event-assignments', controllerConstructor: c47},
	{identifier: 'guest-import-form', controllerConstructor: c48},
	{identifier: 'guest-list-onboarding', controllerConstructor: c49},
	{identifier: 'guest-list-row', controllerConstructor: c50},
	{identifier: 'guests-form', controllerConstructor: c51},
	{identifier: 'guests-individual', controllerConstructor: c52},
	{identifier: 'hotel-event', controllerConstructor: c53},
	{identifier: 'hotel-grid', controllerConstructor: c54},
	{identifier: 'invitation-content-block', controllerConstructor: c55},
	{identifier: 'local-modal', controllerConstructor: c56},
	{identifier: 'mobile-menu', controllerConstructor: c57},
	{identifier: 'nested-form', controllerConstructor: c58},
	{identifier: 'off-canvas-menu', controllerConstructor: c59},
	{identifier: 'onboarding-events-form', controllerConstructor: c60},
	{identifier: 'onboarding-wedding-form', controllerConstructor: c61},
	{identifier: 'open-modal', controllerConstructor: c62},
	{identifier: 'palette-choices', controllerConstructor: c63},
	{identifier: 'password-peek', controllerConstructor: c64},
	{identifier: 'persist-state', controllerConstructor: c65},
	{identifier: 'photo-editor', controllerConstructor: c66},
	{identifier: 'popup-image', controllerConstructor: c67},
	{identifier: 'promo-banner', controllerConstructor: c68},
	{identifier: 'refresh-iframe', controllerConstructor: c69},
	{identifier: 'remote-color-picker-receiver', controllerConstructor: c70},
	{identifier: 'remote-color-picker-sender', controllerConstructor: c71},
	{identifier: 'remote-form-submitter', controllerConstructor: c72},
	{identifier: 'remote-modal', controllerConstructor: c73},
	{identifier: 'remote-page', controllerConstructor: c74},
	{identifier: 'responsive-iframe', controllerConstructor: c75},
	{identifier: 'rsvp--confirm', controllerConstructor: c76},
	{identifier: 'rsvp--continue', controllerConstructor: c77},
	{identifier: 'rsvp--detect-attending', controllerConstructor: c78},
	{identifier: 'rsvp--menu-choices', controllerConstructor: c79},
	{identifier: 'rsvp-form', controllerConstructor: c80},
	{identifier: 'rsvp-group--assign', controllerConstructor: c81},
	{identifier: 'rsvp-group--group-details', controllerConstructor: c82},
	{identifier: 'rsvp-group--transfer', controllerConstructor: c83},
	{identifier: 'selector-filters', controllerConstructor: c84},
	{identifier: 'self-destruct', controllerConstructor: c85},
	{identifier: 'send-to-guests', controllerConstructor: c86},
	{identifier: 'show-hide', controllerConstructor: c87},
	{identifier: 'show-hide-id', controllerConstructor: c88},
	{identifier: 'show-hide-selector', controllerConstructor: c89},
	{identifier: 'stationery--send', controllerConstructor: c90},
	{identifier: 'tabbed', controllerConstructor: c91},
	{identifier: 'tabbed-disable-inputs', controllerConstructor: c92},
	{identifier: 'tabbed-link', controllerConstructor: c93},
	{identifier: 'tabbed-param', controllerConstructor: c94},
	{identifier: 'tabbed-remote', controllerConstructor: c95},
	{identifier: 'tabbed-select', controllerConstructor: c96},
	{identifier: 'table-planner--guest-autocomplete', controllerConstructor: c97},
	{identifier: 'table-row', controllerConstructor: c98},
	{identifier: 'tabs', controllerConstructor: c99},
	{identifier: 'temporary-state', controllerConstructor: c100},
	{identifier: 'thankyou-row', controllerConstructor: c101},
	{identifier: 'thankyous', controllerConstructor: c102},
	{identifier: 'time-ago', controllerConstructor: c103},
	{identifier: 'toggle-boolean', controllerConstructor: c104},
	{identifier: 'toggle', controllerConstructor: c105},
	{identifier: 'tooltip', controllerConstructor: c106},
	{identifier: 'turnstile', controllerConstructor: c107},
	{identifier: 'user-ignored', controllerConstructor: c108},
	{identifier: 'voucher-code', controllerConstructor: c109},
	{identifier: 'website--contact-form', controllerConstructor: c110},
	{identifier: 'website--fetch-contact-form', controllerConstructor: c111},
	{identifier: 'website-anchor-tags', controllerConstructor: c112},
	{identifier: 'website-editor', controllerConstructor: c113},
	{identifier: 'wedding-date', controllerConstructor: c114},
	{identifier: 'yes-no-hide--local', controllerConstructor: c115},
	{identifier: 'yes-no-hide--long-range', controllerConstructor: c116},
	{identifier: 'yes-no-hide--yes-no-hide', controllerConstructor: c117},
];
